function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Rnd } from 'react-rnd';
import queryString from 'query-string';
import Icon from '../icon';

require('./videoviewertask.less');

var searchInfo = queryString.parse(window.location.search);
var forbidRnderInTop = searchInfo.renderInTop === '0'; // 解决本地调试跨域问题

var videoViewerPrefixCls = 'videoviewertask';
var videoComponentId = 'task_video_viewer_video_component';
var HeadHeight = 44;

var VideoViewer = /*#__PURE__*/function (_Component) {
  _inherits(VideoViewer, _Component);

  var _super = _createSuper(VideoViewer);

  function VideoViewer(props) {
    var _this;

    _classCallCheck(this, VideoViewer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getCurVideoIndexData", function (taskList, curTaskVideo) {
      var videoCount = 0;
      var curVideoIndex = 0;
      var curVideoFound = false;
      var curVideoTaskIndex = 0;
      var curVideoTaskInsideIndex = 0;
      taskList.forEach(function (task) {
        videoCount += task.videoList.length;

        if (curTaskVideo && !curVideoFound) {
          task.videoList.some(function (video) {
            curVideoIndex += 1;

            if (video.name === curTaskVideo.name && video.url === curTaskVideo.url) {
              curVideoFound = true;
              return true;
            }

            curVideoTaskInsideIndex += 1;
            return false;
          });
        }

        if (!curVideoFound) {
          curVideoTaskIndex += 1;
          curVideoTaskInsideIndex = 0;
        }
      });
      return {
        curVideoIndex: curVideoIndex,
        videoCount: videoCount,
        curVideoTaskIndex: curVideoTaskIndex,
        curVideoTaskInsideIndex: curVideoTaskInsideIndex
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var closeCallback = _this.props.closeCallback;
      if (closeCallback) closeCallback();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleShowTaskList", function () {
      var showTaskList = _this.state.showTaskList;

      _this.setState({
        showTaskList: !showTaskList
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeCurVideo", function (newCurVideo) {
      console.log('[VideoViewerTask][changeCurVideo] newCurVideo:', newCurVideo);
      var curTaskVideoChangeCallback = _this.props.curTaskVideoChangeCallback;

      if (!curTaskVideoChangeCallback) {
        return;
      }

      curTaskVideoChangeCallback(newCurVideo);
    });

    _defineProperty(_assertThisInitialized(_this), "disablePictureInPicture", function () {
      var curTaskVideo = _this.props.curTaskVideo;

      if (!curTaskVideo) {
        return;
      }

      var vid = document.getElementById(videoComponentId);

      if (vid) {
        vid.disablePictureInPicture = true;
      }

      var vidTop = _this.renderWindow.document.getElementById(videoComponentId);

      if (vidTop) {
        vidTop.disablePictureInPicture = true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "pauseWhenUnVisiable", function () {
      var curTaskVideo = _this.props.curTaskVideo;

      if (!curTaskVideo) {
        return;
      }

      var visible = _this.props.visible;

      if (visible) {
        return;
      }

      if (!_this.refs.vidRef) {
        return;
      }

      _this.refs.vidRef.pause();
    });

    _defineProperty(_assertThisInitialized(_this), "initVideoSizeChange", function () {
      var curTaskVideo = _this.props.curTaskVideo;

      if (!curTaskVideo) {
        return;
      }

      if (!curTaskVideo.url) {
        return;
      }

      var fileName = _this.getFileName(curTaskVideo.url);

      var type = _this.getFileType(fileName);

      if (type === 'mp4') {
        // 时长
        _this.refs.vidRef.onloadedmetadata = function () {
          // window.URL.revokeObjectURL(this.refs.vidRef.src);
          // var duration = this.refs.vidRef.duration;
          console.log('[VideoViewerTask][initVideoSizeChange] onloadedmetadata');

          _this.dealVideoSizeChanged();
        };
      } else {
        console.log('[VideoViewerTask][initVideoSizeChange] not mp4');

        _this.dealVideoSizeChanged();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateSize", function (width) {
      var minWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.minWidth;
      var maxWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props.maxWidth;
      // const { canDragm } = this.props;
      // if (!canDragm) {
      //   return;
      // }
      var _this$state = _this.state,
          videoSrcWidth = _this$state.videoSrcWidth,
          videoSrcHeight = _this$state.videoSrcHeight;
      console.log('[VideoViewerTask][updateSize] videoSrcWidth:', videoSrcWidth, ', videoSrcHeight:', videoSrcHeight);

      if (videoSrcWidth === 0 || videoSrcHeight === 0) {
        return;
      }

      var widthRet = parseInt(width);

      if (widthRet > maxWidth) {
        widthRet = maxWidth;
      }

      if (widthRet < minWidth) {
        widthRet = minWidth;
      }

      var heightRet = HeadHeight + widthRet * videoSrcHeight / videoSrcWidth;
      console.log('[VideoViewerTask][updateSize] widthRet:', widthRet, ', heightRet:', heightRet);
      var size = {
        // 因为加了1px的边框，所以宽度和高度都要+2
        width: widthRet + 2,
        height: heightRet + 2
      };
      var onVideoViewSizeChanged = _this.props.onVideoViewSizeChanged;

      if (onVideoViewSizeChanged) {
        console.log('[VideoViewerTask][updateSize] onVideoViewSizeChanged size:', size);
        onVideoViewSizeChanged(size);
      }

      if (_this.state.width !== size.width) {
        console.log('[VideoViewerTask][updateSize] width changed to:', size.width, ', this.state.width:', _this.state.width);

        _this.setState({
          width: size.width
        });
      }

      if (_this.state.height !== size.height) {
        console.log('[VideoViewerTask][updateSize] height changed to:', size.height, ', this.state.height:', _this.state.height);

        _this.setState({
          height: size.height
        });
      }

      if (_this.rnd) {
        _this.rnd.updateSize(size);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getFileName", function (url) {
      var pos = url.lastIndexOf('/');

      if (pos < 0) {
        return '';
      }

      return url.substr(pos + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "getFileType", function (fileName) {
      var defaultType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mp4';
      var exts = fileName.split('.');
      var ext = defaultType;

      if (exts && exts.length > 1) {
        ext = exts[exts.length - 1];
        ext = ext.toLowerCase();
      }

      return ext;
    });

    _defineProperty(_assertThisInitialized(_this), "initDefalutPosition", function () {
      var isSizeInited = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var canDragm = _this.props.canDragm;

      if (!canDragm) {
        _this.setState({
          isPositionInited: true
        });

        return;
      }

      var isPositionInited = _this.state.isPositionInited;

      if (isPositionInited) {
        return;
      }

      var defaultPosition = _this.props.defaultPosition;

      if (defaultPosition) {
        _this.setState({
          x: defaultPosition.x,
          y: defaultPosition.y,
          isPositionInited: true
        });

        return;
      }

      if (isSizeInited) {
        var _this$state2 = _this.state,
            width = _this$state2.width,
            height = _this$state2.height;
        console.log('[VideoViewerTask][initDefalutPosition] this.renderWindow.innerWidth:', _this.renderWindow.innerWidth, ', this.renderWindow.innerHeight:', _this.renderWindow.innerHeight, ', width:', width, ', height:', height);

        _this.setState({
          x: (_this.renderWindow.innerWidth - width) / 2,
          y: (_this.renderWindow.innerHeight - height) / 2,
          isPositionInited: true
        });

        return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleVideoPlay", function () {
      _this.setState({
        showTaskList: false
      });
    });

    var defaultWidth = props.defaultWidth,
        showTaskListDefault = props.showTaskListDefault;
    _this.state = {
      x: 0,
      y: 0,
      width: defaultWidth,
      height: HeadHeight,
      showTaskList: showTaskListDefault,
      enableClickParent: true,
      videoSrcWidth: 0,
      videoSrcHeight: 0,
      isPositionInited: false
    };
    _this.renderWindow = forbidRnderInTop ? window : window.top;
    return _this;
  }

  _createClass(VideoViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      console.log('[VideoViewerTask][componentDidMount]');
      this.disablePictureInPicture();
      this.initDefalutPosition();
      this.pauseWhenUnVisiable();
      this.initVideoSizeChange();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var showTaskListDefault = this.props.showTaskListDefault;
      var nextShowTaskListDefault = nextProps.showTaskListDefault;

      if (showTaskListDefault !== nextShowTaskListDefault) {
        this.setState({
          showTaskList: nextShowTaskListDefault
        });
      }

      var _this$props = this.props,
          maxWidth = _this$props.maxWidth,
          defaultWidth = _this$props.defaultWidth,
          minWidth = _this$props.minWidth;
      var nextMaxWidth = nextProps.maxWidth;

      if (maxWidth !== nextMaxWidth) {
        this.updateSize(defaultWidth, minWidth, nextMaxWidth);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
        console.log('[VideoViewerTask][shouldComponentUpdate] state changed this.state:', this.state, ', nextState:', nextState);
        return true;
      }

      if (nextProps.curTaskVideo !== this.props.curTaskVideo) {
        console.log('[VideoViewerTask][shouldComponentUpdate] nextProps changed this.props.curTaskVideo:', this.props.curTaskVideo, ', nextProps.curTaskVideo:', nextProps.curTaskVideo);
        return true;
      }

      if (nextProps.visible !== this.props.visible) {
        console.log('[VideoViewerTask][shouldComponentUpdate] nextProps changed this.props.visible:', this.props.visible, ', nextProps.visible:', nextProps.visible);
        return true;
      }

      return false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      console.log('[VideoViewerTask][componentDidUpdate] props:', this.props, ', state:', this.state);
      this.disablePictureInPicture();
      this.pauseWhenUnVisiable();
      this.initVideoSizeChange();
    }
  }, {
    key: "updateVideoSrcSize",
    value: function updateVideoSrcSize() {
      if (!this.refs || !this.refs.vidRef) {
        console.warn('[VideoViewerTask][updateVideoSrcSize] this.refs or this.refs.vidRef is null');
        return;
      }

      var _this$state3 = this.state,
          videoSrcWidth = _this$state3.videoSrcWidth,
          videoSrcHeight = _this$state3.videoSrcHeight;

      if (this.refs.vidRef.videoWidth !== videoSrcWidth) {
        console.log('[VideoViewerTask][updateVideoSrcSize] videoSrcWidth changed to:', this.refs.vidRef.videoWidth, ', videoSrcWidth:', videoSrcWidth);
        this.setState({
          videoSrcWidth: this.refs.vidRef.videoWidth
        });
      }

      if (this.refs.vidRef.videoHeight !== videoSrcHeight) {
        console.log('[VideoViewerTask][updateVideoSrcSize] videoSrcHeight changed to:', this.refs.vidRef.videoHeight, ', videoSrcHeight:', videoSrcHeight);
        this.setState({
          videoSrcHeight: this.refs.vidRef.videoHeight
        });
      }

      console.log('[VideoViewerTask][updateVideoSrcSize] videoSrcWidth:', this.refs.vidRef.videoWidth, ', videoSrcHeight:', this.refs.vidRef.videoHeight);
    }
  }, {
    key: "dealVideoSizeChanged",
    value: function dealVideoSizeChanged() {
      this.updateVideoSrcSize();
      var onVideoSrcSizeChanged = this.props.onVideoSrcSizeChanged;

      if (onVideoSrcSizeChanged) {
        onVideoSrcSizeChanged({
          width: this.refs.vidRef.videoWidth,
          height: this.refs.vidRef.videoHeight
        });
      }

      this.updateSize(this.state.width - 2);
      this.initDefalutPosition(true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          visible = _this$props2.visible,
          canFullScreen = _this$props2.canFullScreen,
          canDownload = _this$props2.canDownload,
          maxWidth = _this$props2.maxWidth,
          maxHeight = _this$props2.maxHeight,
          minWidth = _this$props2.minWidth,
          minHeight = _this$props2.minHeight,
          canDragm = _this$props2.canDragm,
          taskList = _this$props2.taskList,
          curTaskVideo = _this$props2.curTaskVideo;
      var controlsList = ['noremoteplayback', 'footbar'];

      if (!canFullScreen) {
        controlsList.push('nofullscreen');
      }

      if (!canDownload) {
        controlsList.push('nodownload');
      }

      var _this$state4 = this.state,
          width = _this$state4.width,
          height = _this$state4.height,
          x = _this$state4.x,
          y = _this$state4.y,
          showTaskList = _this$state4.showTaskList,
          enableClickParent = _this$state4.enableClickParent,
          isPositionInited = _this$state4.isPositionInited;
      var curVideoIndexData = this.getCurVideoIndexData(taskList, curTaskVideo);
      var showVideoListBtn = curVideoIndexData.videoCount > 0;
      var showCloseBtn = canDragm;
      var VideoDiv = /*#__PURE__*/React.createElement("div", {
        className: "".concat(videoViewerPrefixCls),
        style: {
          display: visible && isPositionInited ? '' : 'none'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(videoViewerPrefixCls, "-content")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(videoViewerPrefixCls, "-content-hd")
      }, /*#__PURE__*/React.createElement("p", {
        className: "".concat(videoViewerPrefixCls, "-content-title")
      }, curTaskVideo.name), showVideoListBtn && /*#__PURE__*/React.createElement("p", {
        className: "".concat(videoViewerPrefixCls, "-content-info"),
        onClick: this.toggleShowTaskList
      }, "\u968F\u5802\u89C6\u9891(".concat(curVideoIndexData.curVideoIndex, "/").concat(curVideoIndexData.videoCount, ")")), showCloseBtn && /*#__PURE__*/React.createElement("a", {
        href: "#",
        className: "".concat(videoViewerPrefixCls, "-content-close"),
        onClick: this.handleClose
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(videoViewerPrefixCls, "-content-bd")
      }, /*#__PURE__*/React.createElement("video", {
        ref: "vidRef",
        id: videoComponentId,
        src: curTaskVideo.url,
        controls: true,
        width: "100%",
        height: "100%",
        "webkit-playsinline": "true",
        playsInline: true,
        "x5-playsinline": "true",
        controlsList: controlsList.join(' '),
        onPlay: this.handleVideoPlay,
        preload: "metadata"
      }, /*#__PURE__*/React.createElement("track", {
        default: true,
        kind: "captions",
        srcLang: "en"
      })), showTaskList && /*#__PURE__*/React.createElement("div", {
        className: "".concat(videoViewerPrefixCls, "-aside")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(videoViewerPrefixCls, "-aside-hd")
      }, /*#__PURE__*/React.createElement("p", {
        className: "".concat(videoViewerPrefixCls, "-aside-title")
      }, "\u968F\u5802\u89C6\u9891"), /*#__PURE__*/React.createElement("a", {
        href: "#",
        className: "".concat(videoViewerPrefixCls, "-aside-close"),
        onClick: this.toggleShowTaskList
      }, /*#__PURE__*/React.createElement(Icon, {
        value: "delete"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(videoViewerPrefixCls, "-aside-bd")
      }, taskList.map(function (taskItem, taskIndex) {
        var isCurrentTask = curVideoIndexData.curVideoTaskIndex === taskIndex;
        return /*#__PURE__*/React.createElement("div", {
          key: taskIndex.toString(),
          className: "".concat(videoViewerPrefixCls, "-aside-topic ").concat(isCurrentTask ? 'current' : '')
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(videoViewerPrefixCls, "-aside-topic-hd")
        }, /*#__PURE__*/React.createElement("p", {
          className: "".concat(videoViewerPrefixCls, "-aside-topic-title")
        }, taskItem.name)), /*#__PURE__*/React.createElement("div", {
          className: "".concat(videoViewerPrefixCls, "-aside-topic-bd")
        }, /*#__PURE__*/React.createElement("ul", {
          className: "".concat(videoViewerPrefixCls, "-aside-topic-list")
        }, taskItem.videoList.map(function (videoItem, videoIndex) {
          var isCurrent = isCurrentTask && curVideoIndexData.curVideoTaskInsideIndex === videoIndex;
          return /*#__PURE__*/React.createElement("li", {
            key: videoIndex.toString(),
            className: "".concat(videoViewerPrefixCls, "-aside-topic-item ").concat(isCurrent ? 'current' : ''),
            onClick: function onClick() {
              _this2.changeCurVideo(videoItem);
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "".concat(videoViewerPrefixCls, "-aside-topic-item-label")
          }, /*#__PURE__*/React.createElement(Icon, {
            value: "play"
          })), videoItem.name);
        }))));
      }))))));
      return canDragm ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          zIndex: '100',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          position: enableClickParent ? '' : 'absolute'
        }
      }), /*#__PURE__*/React.createElement(Rnd, {
        size: {
          width: width,
          height: height
        },
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        position: {
          x: x,
          y: y
        },
        onDragStart: function onDragStart(e, d) {
          console.log('[VideoViewerTask][onDragStart]');

          _this2.setState({
            enableClickParent: false
          });
        },
        onDragStop: function onDragStop(e, d) {
          console.log('[VideoViewerTask][onDragStop] d:', d);

          _this2.setState({
            x: d.x,
            y: d.y
          });

          _this2.setState({
            enableClickParent: true
          });
        },
        onResizeStart: function onResizeStart(e, direction, ref) {
          console.log('[VideoViewerTask][onResizeStart]');

          _this2.setState({
            enableClickParent: false
          });
        },
        onResizeStop: function onResizeStop(e, direction, ref, delta, position) {
          console.log('[VideoViewerTask][onResizeStop], position:', position);

          _this2.updateSize(ref.style.width);

          _this2.setState(_objectSpread({}, position));

          _this2.setState({
            enableClickParent: true
          });
        },
        onResize: function onResize(e, direction, ref, delta, position) {
          console.log('[VideoViewerTask][onResize], position:', position);

          _this2.updateSize(ref.style.width);

          _this2.setState(_objectSpread({}, position));
        },
        style: {
          zIndex: 100,
          display: visible ? '' : 'none'
        },
        ref: function ref(c) {
          _this2.rnd = c;
        }
      }, VideoDiv)) : VideoDiv;
    }
  }]);

  return VideoViewer;
}(Component);

_defineProperty(VideoViewer, "propTypes", {
  visible: PropTypes.bool,
  closeCallback: PropTypes.func,
  canFullScreen: PropTypes.bool,
  canDownload: PropTypes.bool,
  maxWidth: PropTypes.number,
  minWidth: PropTypes.number,
  defaultWidth: PropTypes.number,
  canDragm: PropTypes.bool,
  taskList: PropTypes.any,
  curTaskVideo: PropTypes.any,
  curTaskVideoChangeCallback: PropTypes.func,
  showTaskListDefault: PropTypes.bool,
  defaultPosition: PropTypes.any,
  onVideoSrcSizeChanged: PropTypes.func,
  onVideoViewSizeChanged: PropTypes.func
});

_defineProperty(VideoViewer, "defaultProps", {
  visible: false,
  closeCallback: null,
  canFullScreen: false,
  canDownload: false,
  maxWidth: 1200,
  minWidth: 300,
  defaultWidth: 560,
  canDragm: false,
  taskList: [],
  curTaskVideo: {
    name: '',
    url: ''
  },
  curTaskVideoChangeCallback: null,
  showTaskListDefault: false,
  defaultPosition: null,
  onVideoSrcSizeChanged: null,
  onVideoViewSizeChanged: null
});

export default VideoViewer;